import * as React from "react";
import { Grid } from "@mui/material";

import { DynamicField } from "@/components/dynamicField/dynamic-field";

export function AdvancedSettings({ control, settings }: { control: any; settings: any }) {
	return (
		<Grid container spacing={2}>
			{settings.map((setting: any) => (
				<Grid
					key={setting.name}
					size={{
						md: 12,
						xs: 12,
					}}
				>
					<DynamicField
						control={control}
						type={setting.type}
						name={`settings.${setting.name}`}
						label={setting.label}
						dynamicField={setting}
						formName="settings"
					/>
				</Grid>
			))}
		</Grid>
	);
}
